<template>
  <v-container>
    <v-card class="mx-auto" max-width="344">
      <v-tabs v-model="tab" background-color="oug" dark fixed-tabs>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card>
            <v-card-text>
              <div>Current Accreditation</div>
              <p
                class="text-h4 text--primary"
                v-if="this.currentAccred.Accred_Name != null"
              >
                {{ this.currentAccred.Accred_Name }}
              </p>
              <p
                class="text-h4 text--primary"
                v-if="this.currentAccred.Accred_Name == null"
              >
                N/A
              </p>
              <p>
                <i>Expires: {{ this.currentAccred.End_date }} </i>
              </p>
              <v-divider></v-divider>
              <p class="mt-3">
                <i>Blue Card No. {{ this.blueCardNo }} </i>
              </p>
              <p class="mt-n4">
                <i>Blue Card Expiry: {{ this.blueCardExp }}</i>
              </p>
              <h3 class="mb-2"><u>Accreditation Policy</u></h3>
              <v-container fluid class="mt-n3">
                <!-- <v-col cols="12"> -->
                <div class="checks">
                  <v-icon color="green">mdi-check-circle-outline</v-icon>
                  <p class="ml-1 ma-0">Registered on Coaches App</p>
                </div>
                <div v-if="this.blueCardNo != null" class="checks">
                  <v-icon color="green">mdi-check-circle-outline</v-icon>
                  <p class="ml-1 ma-0">Blue Card No. linked to Profile</p>
                </div>
                <div
                  v-if="this.currentAccred.Accred_Name != null"
                  class="checks"
                >
                  <v-icon color="green">mdi-check-circle-outline</v-icon>
                  <p class="ml-1 ma-0">Have a valid Accreditation</p>
                </div>
                <div v-if="this.newAccredDate <= this.newToday" class="checks">
                  <v-icon color="red">mdi-alert-circle-outline</v-icon>
                  <p class="ml-1 ma-0">Accreditation Has Expired/Not Active</p>
                </div>
                <div v-if="this.blueCardNo == null" class="checks">
                  <v-icon color="red">mdi-alert-circle-outline</v-icon>
                  <p class="ml-1 ma-0">Blue card number not in Profile</p>
                </div>
                <div v-if="this.blueCardExp == null" class="checks">
                  <v-icon color="red">mdi-alert-circle-outline</v-icon>
                  <p class="ml-1 ma-0">Blue card expiry not in Profile</p>
                </div>
                <div v-if="(this.blueCardExp != null) && (this.newBlueCardExp <= this.newToday)" class="checks">
                  <v-icon color="red">mdi-alert-circle-outline</v-icon>
                  <p class="ml-1 ma-0">Blue card has expired</p>
                </div>
                <div
                  v-if="this.currentAccred.Accred_Name == null"
                  class="checks"
                >
                  <v-icon color="red">mdi-alert-circle-outline</v-icon>
                  <p class="ml-1 ma-0">No Accreditation linked to Profile</p>
                </div>
                <!-- </v-col> -->
              </v-container>
              <p></p>
              <div class="mb-n5 mt-n4">
                <p
                  v-if="
                    this.blueCardNo != null &&
                    this.currentAccred.Accred_Name != null &&
                    this.newAccredDate > this.newToday &&
                    this.blueCardExp != null &&
                    this.newBlueCardExp > this.newToday
                  "
                  class="validAccred"
                >
                  <b>Congratulations! You are a Fully Licensed BQ Coach!</b>
                </p>
                <p
                  v-if="
                    this.blueCardNo == null ||
                    this.currentAccred.Accred_Name == null ||
                    this.newAccredDate < this.newToday ||
                    this.blueCardExp == null ||
                    this.newBlueCardExp <= this.newToday
                  "
                  class="inValidAccred"
                >
                  <b
                    >You have not achieved all of the above requirements to
                    become fully licensed. <a href="/Help">Click here</a> to see
                    how you can do so</b
                  >
                </p>
              </div>
            </v-card-text>
            <div>
              <v-dialog
                v-model="loadingDialog"
                hide-overlay
                persistent
                width="300"
              >
                <v-card color="oug" dark>
                  <v-card-text>
                    Loading Accreditation. Please Stand By
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0"
                    ></v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <v-card-text
              ><b
                >The following is a list of Modules that you have completed. If
                you have any questions about your completed modules or the
                status of your Accreditation, you can contact Luke McGuire in
                the People section of the app.</b
              ></v-card-text
            >
            <v-divider></v-divider>
            <v-list>
              <v-list-item v-for="(item, i) in this.Modules" :key="i">
                <v-list-item-content>
                  <v-list-item-title v-text="item.Created"></v-list-item-title>
                  <v-list-item-title v-text="item.Module"></v-list-item-title>
                  <v-divider class="mt-2"></v-divider>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div class="mt-2" v-if="this.Modules == 0">
              <v-container>
              <p align="center">
                You have no completed Modules. To complete modules, you can do
                so from the 'Courses/Online Components' section of the Coaches
                App. If you believe you have completed a module but nothing is
                appearing, contact Luke McGuire in the People section of the App
              </p>
              </v-container>
            </div>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <v-card-actions class="justify-center">
        <v-btn text color="deep-purple accent-4" to="Pathway">
          Explore Coach Pathways
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { authComputed, getUser } from "../veux/helpers";
import dayjs from "../common/Functions/daysFunctons";

export default {
  data: () => ({
    Modules: [],
    currentAccred: [],
    allAccreds: [],
    Accred_Name: "",
    blueCardExp: null,
    blueCardNo: null,
    newBlueCardExp: "",
    newAccredDate: "",
    newToday: "",
    absolute: true,
    overlay: false,
    interval: {},
    show: false,
    nextAccred: false,
    tab: null,
    items: ["Status", "Modules"],
    loadingDialog: false,
  }),
  created() {
    this.loadAccreds();
    this.checkBlueCard();
    this.loadModules();
    console.log("modules", this.userModules)
  },
  methods: {
    checkValidation() {
      // TODO: IF there is no accrediation, the blue card expiry validation does not work. E.g the code exits at line 202.
      if(this.accredExp != null){
      this.newAccredDate = new Date(
        this.accredExp.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
      );
      }else{
      console.log("No Accred Exp")
      }
      if(this.today){
      this.newToday = new Date(
        this.today.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
      );
      }else{
        console.log("Date Found")
      }
      var dateParts = this.blueCardExp.split("/");
      // month is 0-based, that's why we need dateParts[1] - 1
      this.newBlueCardExp = new Date(
        +dateParts[2],
        dateParts[1] - 1,
        +dateParts[0]
      );
      // THIS IS OLD CODE FOR CODE REVIEW: this.newBlueCardExp = new Date(this.blueCardExp);
      // check if they have an accreditation
      if (this.currentAccred) {
        // Check Date is valid
        if (this.newAccredDate > this.newToday) {
          // Set Accreditation tick to green
          this.message = "Accred Ok";
          // console.log("Message 1: ", this.message)
        } else {
          // Set Accreditation tick to red
          this.message = "Your Accreditation is Expired";
        }
      } else {
        // Set Accreditation tick to red
        this.message = "You do not have an accreditation in OwnUrGoal";
      }

      // Check Blue Card
      if (this.blueCardNo && this.blueCardExp) {
        // Check Date is valid
        if (this.newBlueCardExp > this.newToday) {
          // Set Blue Card tick to green
          this.message = "Blue Card Expiry Ok";
        } else {
          // Set Blue Card tick to red
          this.message = "Your Blue Card is Expired";
        }
      } else {
        // Set Blue Card tick to red
        this.message = "You do not have an Blue Card in OwnUrGoal";
      }
      console.log("Message: ", this.message);
    },

    loadAccreds() {
      this.today = dayjs.formatDate(new Date(), "DD-MM-YYYY");
      // Load Accreditations by type from the Coaches App
      const payload = { Contact_id: this.currentUser.Contact_id, Team_id: 423 };
      this.loadingDialog = true;
      const baseURL = "https://server.ownurgoal.net.au/gen/GetAccreds";
      axios
        .post(baseURL, payload)
        .then((response) => {
          this.allAccreds = response.data.result;
          if (this.allAccreds.length >= 1) {
            this.currentAccred = this.allAccreds[0];
            this.accredExp = this.currentAccred.End_date;
          } else {
            this.Accred_Name == "N/A";
            this.loadingDialog = false;
          }
          this.checkValidation();
          this.loadingDialog = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = "Error trying to load Accreditations please try again";
        });
    },

    loadModules() {
      let payload = { Contact_id: this.currentUser.Contact_id };
      const baseURL = "https://server.ownurgoal.net.au/gen/GetModules";
      axios.post(baseURL, payload).then((response) => {
        this.Modules = response.data.result;
        this.Modules.forEach((element) => {
          this.ModuleNames = element.Module + " - " + element.Created;
        });
      });
    },

    // Check if blue card is listed in contact details in local storage
    checkBlueCard() {
      this.contactDetails = JSON.parse(
        localStorage.getItem("Coach")
      ).contact_details;
      this.contactDetails.forEach((element) => {
        if (element.Code === 290) {
          this.blueCardNo = element.Description;
        }
        if (element.Code === 309) {
          this.blueCardExp = element.Description;
        }
      });
    },
  },
  computed: {
    ...authComputed,
    ...getUser,
  },
};
</script>

<style scoped>
.checks {
  display: inline-flex;
}

.validAccred {
  border: 3px solid;
  border-color: green;
  color: green;
  padding: 1em;
  border-radius: 25px;
}

.inValidAccred {
  border: 3px solid;
  border-color: red;
  color: red;
  padding: 1em;
  border-radius: 25px;
}
</style>
